import { formatTime } from './time';
import { DAY_ORDER, DAY_SHORT, DayHours, DayKey, OperatingHours } from './types';

// A day's rendered value: "Closed", "7:00 AM–4:00 PM", or null (unknown → skip).
const dayDisplay = (day: DayHours): string | null => {
  if (day.closed) return 'Closed';
  if (day.open && day.close) return `${formatTime(day.open)}–${formatTime(day.close)}`;
  return null;
};

// One-line summary grouping consecutive same-value days. Mirrors the server's
// summarizeOperatingHours so the editor preview matches the BOL and email.
export const summarizeHours = (hours: OperatingHours | null): string => {
  if (!hours) return '';

  const segments: string[] = [];
  let runStart: DayKey | null = null;
  let runEnd: DayKey | null = null;
  let runValue: string | null = null;

  const flush = () => {
    if (!runStart || !runEnd || !runValue) return;
    const range =
      runStart === runEnd ? DAY_SHORT[runStart] : `${DAY_SHORT[runStart]}–${DAY_SHORT[runEnd]}`;
    segments.push(`${range} ${runValue}`);
    runStart = runEnd = runValue = null;
  };

  for (const day of DAY_ORDER) {
    const value = dayDisplay(hours[day]);
    if (value === null) {
      flush();
      continue;
    }
    if (value === runValue) {
      runEnd = day;
    } else {
      flush();
      runStart = runEnd = day;
      runValue = value;
    }
  }
  flush();

  return segments.join(' · ');
};
